export const getFleckPosition = (index: number) => ({
    // top left
    0: {
        top: -75,
        left: -50
    },
    // top right
    1: {
        top: -75,
        right: -50
    },
    // bottom left
    2: {
        bottom: -75,
        left: -50
    },
    // bottom right
    3: {
        bottom: -75,
        right: -50
    },
    // center
    4: {
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)'
    },
    // center left
    5: {
        top: '50%',
        left: 50,
        transform: 'translateY(-50%)'
    },
    // center right
    6: {
        top: '50%',
        left: 0,
        transform: 'translateY(-50%)'
    },
    // center center
    7: {
        top: -75,
        left: '50%',
        transform: 'translateX(-50%)'
    }
})[index];